import React from 'react';
import { RadioGroup } from '@mui/material';

import { Card, Tag } from 'components';
import Radio from 'components/layout/Radio';

import style from 'styles/Shared.module.scss';

const OrderOptions = ({ groupName, sectionTitle, options = [], setCurrentOption, currentOption, showError, errorMessage }) => {
  return (
    <Card className={style.wrapper}>
      <div className={style.defaultWrapper}>
        <h2 className={style.cardTitle}>{sectionTitle}</h2>
        <RadioGroup name={groupName}>
          {options.length > 0 ? (
            options.map(({ name, id }) => (
              <Radio
                onChange={() => setCurrentOption(id)}
                value={currentOption === id}
                content={name}
                key={id}
              />
            ))
          ) : (
            <Tag value={'Brak sposobów płatności'} />
          )}
        </RadioGroup>
        {showError && <p>{errorMessage}</p>}
      </div>
    </Card>
  );
};

export default OrderOptions;
